
import React from "react";
import "./DeleteUserPopup.css";

export default function DeleteUserPopup({ onCancel, onConfirm }) {
  return (
    <div className="pop-up-container active">
      <div className="pop-up-wrapper">
        <img
          src="https://cdn-icons-png.flaticon.com/512/463/463612.png"
          alt="Warning"
        />
        <h2>Are you sure?</h2>
        <p>The User will be deleted!!</p>
        <div style={{ display: "flex", gap: "10px" }}>
          <button className="cancel" onClick={onCancel}>
            No, cancel plx!
          </button>
          <button className="ok" onClick={onConfirm}>
            Yes, delete it!
          </button>
        </div>
      </div>
    </div>
  );
}